













import { Vue, Component } from "vue-property-decorator";
import { DetectState } from "./_state";
import LogDetectStepFirst from "@/modules/log/LogDetectStepFirst.vue";
import LogDetectStepSecond from "@/modules/log/LogDetectStepSecond.vue";
import PanelDetectionWaiting from "@/components/PanelDetectionWaiting.vue";

@Component({
  components: {
    LogDetectStepFirst,
    LogDetectStepSecond,
    PanelDetectionWaiting
  },
  metaInfo: {
    title: "LOG在线检测"
  }
})
export default class extends Vue {
  step = 0;

  get waitingDetection() {
    return DetectState.waitingDetection;
  }
  goBack() {
    this.$router.push("/detect/chooseType");
  }
}
